<template>
    <form-row title="Is additional money due to Extend?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean-reactive
                name="feasibility_additional_money_is_due"
                v-model="feasibility_additional_money_is_due"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-money
                v-if="feasibility_additional_money_is_due"
                name="feasibility_additional_money_amount"
                v-model="feasibility_additional_money_amount"
                class="sm:ml-12"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
    },

    computed: {
        feasibility_additional_money_is_due: {
            get() {
                return store.state.feasibility_additional_money_is_due;
            },
            set(val) {
                store.state.feasibility_additional_money_is_due = val;
            },
        },
        feasibility_additional_money_amount: {
            get() {
                return store.state.feasibility_additional_money_amount;
            },
            set(val) {
                store.state.feasibility_additional_money_amount = val;
            },
        },
    },
}
</script>
